import makeCrud from '@/store/site/localization/crud'

// Seçenekler (select/multiselect/color alanları için) — label çeviri tablosuna gider.
export default makeCrud('ecommerce_product_attribute_option')
